import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';
import { ElUploadInternalFileDetail } from 'element-ui/types/upload';

import { E取込分類, E取込形式 } from '@/openapi/enum';
import { 取込ListItemResponse, 部門ListItemResponse } from '@/openapi/user';

import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';
import 取込Mixin from '@/entries/user/mixins/取込Mixin';
import 決算期Utility from '@/classes/common/決算期Utility';

export type RowInfo = {
  取込分類: E取込分類;
  部門?: 部門ListItemResponse;
};

export default mixins(事業所Mixin, 取込Mixin).extend({
  name: 'C取込表',

  props: {
    取込形式: {
      type: Number as PropType<E取込形式>,
      required: true,
    },
    rowInfos: {
      type: Array as PropType<RowInfo[]>,
      default: () => [],
    },
    部門s: {
      type: Array as PropType<部門ListItemResponse[]>,
      default: () => [],
    },
    取込s: {
      type: Array as PropType<取込ListItemResponse[]>,
      default: () => [],
    },
  },

  data(): {
    e取込分類: typeof E取込分類;
    決算期数: number;
    決算期s: number[];
    決算年s: number[];
  } {
    return {
      e取込分類: E取込分類,
      決算期数: 決算期Utility.過去決算期数 + 1,
      決算期s: [],
      決算年s: [],
    };
  },

  computed: {
    count試算表Row(): number {
      return this.rowInfos.filter(
        (r) => r.取込分類 === E取込分類.月次貸借対照表 || r.取込分類 === E取込分類.月次損益計算書_月次製造原価報告書
      ).length;
    },
    取込sOf取込形式(): 取込ListItemResponse[] {
      return this.取込s.filter((取) => 取.c取込形式 === this.取込形式);
    },
  },

  created(): void {
    this.決算期s = 決算期Utility.get決算期Yms(this.事業所.c計画0期の決算期, this.決算期数, true);
    this.決算年s = 決算期Utility.get決算年s(this.事業所.c計画0期の決算期, this.決算期数, true);
  },

  methods: {
    isJoin決算書(取込分類: E取込分類): boolean {
      return this.取込形式 === E取込形式.xlsx && 取込分類 === E取込分類.決算書;
    },
    isFirst部門RowIn取込分類(部門: 部門ListItemResponse): boolean {
      if (this.部門s.length === 0) return false;
      return this.部門s[0].c部門コード === 部門.c部門コード;
    },
    can取込(取込分類: E取込分類, colNum: number): boolean {
      switch (取込分類) {
        case E取込分類.決算書:
          return colNum !== this.決算期数;
        case E取込分類.固定資産台帳:
          return colNum === this.決算期数 - 1;
        default:
          return colNum === this.決算期数;
      }
    },
    buttonLabel(取込分類: E取込分類, 決算年: number, 部門?: 部門ListItemResponse): string {
      const 取込 = this.取込sOf取込形式.find((取) => {
        const check取込分類And年 = 取.c取込分類 === 取込分類 && 取.c年 === 決算年;
        const check部門 = 部門 !== undefined ? 取.c部門PK === 部門.pk : true;
        return check取込分類And年 && check部門;
      });
      return 取込 !== undefined ? '○' : '×';
    },
    selectCell(取込分類: E取込分類, 決算年: number, 部門?: 部門ListItemResponse): void {
      const 部門pk = 部門 !== undefined ? 部門.pk : undefined;
      this.setImportInfo(this.取込形式, 取込分類, 決算年, 部門pk);
    },
    selectFile(file: ElUploadInternalFileDetail) {
      if (!this.selectImportFile(this.取込形式, file)) return;

      this.$emit('selectFile');
    },
  },
});
